export const ROW_HEIGHT = 56;
export const SCROLLBAR_SIZE = 15;
